import {
  Download1Stroke,
  PlusStroke,
  RefreshCircle1ClockwiseStroke,
  SignPostLeftStroke
} from '@lineiconshq/free-icons';
import { ActionBarV2, ActionButtonV2 } from '@/components/custom/erp';

interface Props {
  printedSample: MuaHangRecord[];
  onSearch: () => void;
  onCreate: () => void;
  onRefresh: () => void;
  onPinColumns: () => void;
  onPrintEditClick: () => void;
  isEditDisabled?: boolean;
  className?: string;
}

export function ActionBar({
  className,
  printedSample,
  onSearch,
  onCreate,
  onRefresh,
  onPinColumns,
  onPrintEditClick,
  isEditDisabled = true
}: Props) {
  return (
    <ActionBarV2
      className={className}
      titleComponent={<h1 className='relative text-xl font-bold'>Phân bổ tiền hàng trả cho các hóa đơn</h1>}
    >
      <>
        <ActionButtonV2 icon={PlusStroke} title='Tìm kiếm' onClick={onSearch} variant='primary' shortcut='Alt + N' />
        <ActionButtonV2 icon={RefreshCircle1ClockwiseStroke} title='Refresh' onClick={onRefresh} />
        <ActionButtonV2 icon={SignPostLeftStroke} title='Cố định cột' onClick={onPinColumns} />
        <ActionButtonV2
          icon={Download1Stroke}
          title='Kết xuất dữ liệu'
          onClick={onPrintEditClick}
          shortcut='Alt + D, Ctrl + D'
          disabled={isEditDisabled}
        />
      </>
    </ActionBarV2>
  );
}
